import moment from 'moment';
import React from 'react';

import Icon from 'components/Icon';

const CalendarToolbar = ({ className, prevMonth, nextMonth, current }) => (
    <div className={className}>
        <button
            className="datepicker-btn"
            disabled={current.isSame(moment(), 'month')}
            onClick={(e) => {
                prevMonth();
                e.preventDefault();
                e.stopPropagation();
            }}
            type="button"
        >
            <Icon type="chevron-left" width="9px" height="9px" color="#fff" />
        </button>

        <button
            className="datepicker-btn"
            onClick={(e) => {
                nextMonth();
                e.preventDefault();
                e.stopPropagation();
            }}
            type="button"
        >
            <Icon type="chevron-right" width="9px" height="9px" color="#fff" />
        </button>
    </div>
);

export default CalendarToolbar;
